import {
    SET_ROLES
} from '../const/';
import {createAction} from  './defaults';

export const setRoles = createAction(SET_ROLES);